import React, { useMemo } from "react";
//ultils
// import moment from "moment";
import currency from "../../../utils/currency";
import { date } from "../../../utils/dateTime";
//data
import { useData } from "../../../components/firebase/DataProvider";
//material
import Typography from "@material-ui/core/Typography";
// import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import useStyle from "./style";

function ListItemMap({ data }) {
  const classes = useStyle();
  const { kode_order, created_at, order_info_owner_id, status_pengiriman } =
    data;
  const { level, profil } = useData();

  const komisi = useMemo(() => {
    const field = `ref_${level.level}_komisi`;
    if (data[field]) {
      return data[field];
    }
    return 0;
  });

  return (
    <>
      <ListItem button>
        <ListItemIcon>
          <AttachMoneyIcon color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography className={classes.liquid}>
              Komisi {order_info_owner_id == profil.id ? "Tukuyok" : "Jaringan"}
            </Typography>
          }
          secondary={
            <div>
              <Typography className={classes.liquidSecondList}>
                Order #{kode_order}
              </Typography>

              <Typography className={classes.liquidSecondList}>
                {date(created_at)}
              </Typography>
            </div>
          }
        />
        <ListItemSecondaryAction>
          <IconButton edge="end" size="small">
            <Typography
              className={classes.liquidThird}
              style={{
                color: status_pengiriman === "queued" ? "#fa8e00" : "#27AE60",
              }}
            >
              {currency(komisi)}
            </Typography>
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </>
  );
}

export default ListItemMap;
